<template src='./project-settings.html'></template>

<script>
import Vue from 'vue'
import ContextPage from '@/components/misc/context-page/ContextPage.vue'
import { authorizedOrganizationId, hasProjectManageClaim } from '@/router/auth'
import { required, maxLength } from 'vuelidate/lib/validators'
import { EventBus } from '@/router/bus'
import { validationMixin } from '@/mixins/validation'

export default {
  components: {
    ContextPage
  },
  mixins: [validationMixin],
  data () {
    return {
      projectCode: this.$route.params.projectCode,
      updatedCode: this.$route.query.updatedCode,
      ProjectStatus: {
        PENDING: 0,
        FINISHED: 1
      },
      project: {},
      dialog: false,
      pageLoader: false
    }
  },
  computed: {
    canManageProject () {
      return hasProjectManageClaim() && authorizedOrganizationId() === this.project.organizationId && this.project.status === this.ProjectStatus.PENDING
    },
    codeErrors () {
      return this.getValidationErrorsByName('code')
    },
    nameErrors () {
      return this.getValidationErrorsByName('name')
    }
  },
  created () {
    this.setupPage()
  },
  mounted () {
    EventBus.$emit('reload-crumbs')
  },
  methods: {
    setupPage () {
      this.showLoader(true)
      this.$http.get(Vue.$apiConfig.projectDetailsGet + '/' + this.$route.params.projectCode)
        .then(
          response => {
            this.logConsole(response)
            this.project = response.data.payload
            if (this.updatedCode) {
              EventBus.$emit('alert', {
                variant: 'success',
                message: this.$t('projects.updateProjectSuccessful'),
                errors: []
              })
            }
            this.showLoader(false)
          },
          error => {
            this.formatErrorResponse(error)
            this.showLoader(false)
          }
        )
    },
    validateBeforeProjectSubmit () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$nextTick(function () {
          document.body.scrollTop = 0
        })
        return
      }
      this.saveSettings()
    },
    saveSettings () {
      this.showLoader(true)
      this.pageLoader = true
      this.$http.put(Vue.$apiConfig.updateProjectPut + '/' + this.projectCode, this.project).then(
        response => {
          this.logConsole(response)
          if (this.projectCode !== this.project.code) {
            this.$router.replace({ params: { projectCode: this.project.code }, query: { updatedCode: true } })
          } else {
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t('projects.updateProjectSuccessful'),
              errors: []
            })
          }
          this.showLoader(false)
          this.pageLoader = false
        },
        error => {
          this.formatErrorResponse(error)
          this.showLoader(false)
          this.pageLoader = false
        })
    },
    showLoader  (loader) {
      EventBus.$emit('projectLoader', loader)
    },
    getValidationErrorsByName (name) {
      if (this.$v.project && !this.$v.project[name].$dirty) return []
      return this.getValidationErrors('project').filter((x) => { return x.field === name }).map(x => x.msg)
    }
  },
  validations () {
    const rules = {}

    Object.assign(rules, {
      name: {
        maxLength: maxLength(512)
      },
      code: {
        required,
        maxLength: maxLength(20)
      }
    })

    return {
      project: rules
    }
  }
}
</script>
